// src/pages/Payments/styles.ts
import styled from "styled-components";

export const PageBackground = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  background-color: ${(props) => props.theme.tokens.colors.bg};
`;

export const PageShell = styled.div`
  width: 100%;
  max-width: 480px;
  min-height: 100vh;
  padding-bottom: 24px;
`;

export const LoadingScreen = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  gap: 16px;
  background-color: ${(p) => p.theme.tokens.colors.bg};
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const LoadingTitle = styled.div`
  font-weight: 800;
  font-size: 15px;
  color: ${(p) => p.theme.tokens.colors.muted};
`;

